import { render } from "./HiddenSearchbox.vue?vue&type=template&id=4c0afe60&scoped=true&ts=true"
import script from "./HiddenSearchbox.vue?vue&type=script&lang=ts"
export * from "./HiddenSearchbox.vue?vue&type=script&lang=ts"

import "./HiddenSearchbox.vue?vue&type=style&index=0&id=4c0afe60&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0afe60"]])

export default __exports__